<style>
#AddUser .v--modal-box.v--modal {
  min-height: 200px !important;
  min-width: 500px !important;
}
#AddUser .v-input__slot,
#AddUser .v-text-field__slot label {
  font-size: 12px;
}
#AddUser ul {
  list-style-type: initial;
  padding-left: 20px;
}
</style>

<template>
  <Modal
    modalName="AddUser"
    title="Dodawanie użytkownika"
    @saved="save"
    @closed="close"
    :buttons="['save']"
  >
    <div class="wrapper">
      <p
        xs12
        style="margin-top: 20px;"
      >W celu utworzenia nowego użytkownika wpisz jego email (który jest jednocześnie nazwą użytkownika), a następnie nowe hasło. Musi ono spełniać następujące warunki:</p>
      <ul xs12>
        <li>Hasło musi być dłuższe niż 6 znaków,</li>
        <li>Wymagana jest co najmniej jedna wielka litera, jedna cyfra oraz jeden znak specjalny.</li>
      </ul>
      <span style="display: flex">
        <v-flex xs5>
          <div class="input__wrapper">
            <v-text-field
              v-model="username"
              id="username"
              :rules="[rules.required, rules.email]"
              label="Nazwa"
            ></v-text-field>
          </div>
        </v-flex>
        <v-spacer/>
        <v-flex xs5>
          <div class="input__wrapper">
            <v-text-field
              v-model="password"
              id="password"
              type="password"
              oncopy="return false"
              onpaste="return false"
              :rules="[rules.required, rules.bigLetter, rules.len, rules.specialCase]"
              label="Hasło"
            ></v-text-field>
          </div>
        </v-flex>
      </span>
    </div>
  </Modal>
</template>

<script>
import Modal from "../../../../shared/Modal";

export default {
  components: {
    Modal
  },
  data: () => ({
    username: undefined,
    password: undefined,
    rules: {
      email: v => /.+@.+/.test(v) || "Niepoprawny adres email",
      required: value => !!value || "Pole wymagane",
      bigLetter: value => /[A-Z]/.test(value) || "Wymagana jest wielka litera",
      len: value => value.length > 6 || "Hasło musi być dłuższe niż 6 znaków",
      specialCase: value =>
        /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(value) ||
        "Wymagany jest znak specjalny"
    }
  }),
  computed: {},
  methods: {
    save() {
      if (!this.username || !this.password) {
        this.$root.$emit(
          "showSnackbar",
          "red",
          "Uzupełnij wszystkie wymagane pola"
        );
        return;
      }
      const self = this;
      let payload = {
        name: this.username,
        password: this.password
      };
      this.$store.dispatch("addUser", payload).then(response => {
        if (response.status == 200) {
          this.$root.$emit(
            "showSnackbar",
            "success",
            "Poprawnie dodano użytkownika"
          );
          this.$root.$emit("newUserAdded");
          this.$modal.hide("AddUser");
          self.close();
        } else {
          this.$root.$emit("showSnackbar", "red", `${response}`);
        }
      });
    },
    close() {
      this.username = undefined;
      this.password = undefined;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/settings/modals/userManagement/AddUser.vue